import i18next, { changeLanguage } from 'i18next';
import { useEffect, useState } from 'react';

// eslint-disable-next-line
const getTranslate = (key: string) => {
  const [translate, setTranslate] = useState<string | null>(null);

  useEffect(() => {
    let result = key;
    const defaultLanguage = 'en';
    // let defaultLanguage = 'pt-BR';
    // const data = localStorage.getItem('eaibilling::token');
    // if (data) {
    //   const { user } = JSON.parse(data);
    //   if (user) {
    //     if (user.language === 'English') {
    //       defaultLanguage = 'en-US';
    //     }
    //   }
    // }

    changeLanguage(defaultLanguage);
    if (key) result = i18next.t(key);
    setTranslate(result);
  }, []);

  return translate;
};

export default getTranslate;
